import { parseContract } from '../contracts/generated/contracts.js';

const PREFIX = 'corecry.statistics.view.v1:';
const TTL = 30 * 60 * 1000;
const MAX_BYTES = 2 * 1024 * 1024;
const storage = () => { try { return globalThis.sessionStorage; } catch { return null; } };
export const statisticsViewerKey = (user) => user?.user_id ? `${user.user_id}:${user.switched_by_admin ? 'impersonated' : 'direct'}:${user.is_owner ? 'owner' : 'user'}` : null;

export function clearStatisticsViews() {
    try {
        const target = storage();
        for (let i = (target?.length || 0) - 1; i >= 0; i--) {
            const key = target.key(i);
            if (key?.startsWith(PREFIX)) target.removeItem(key);
        }
    } catch { /* Optional rendering cache. */ }
}

export function readStatisticsView(viewer, defaults) {
    if (!viewer) return null;
    try {
        const saved = JSON.parse(storage()?.getItem(PREFIX + viewer) || 'null');
        if (!saved) return null;
        const controls = Object.fromEntries(Object.entries(defaults).map(([key, value]) => [key, typeof saved.controls?.[key] === 'string' ? saved.controls[key] : value]));
        const selection = { controls };
        if (!Number.isFinite(saved.savedAt) || Date.now() - saved.savedAt < 0 || Date.now() - saved.savedAt >= TTL) return selection;
        try {
            for (const [name, data] of Object.entries({ context: saved.context, ...saved.sections })) {
                parseContract(`statistics_${name}_response`, { success: true, data, api_version: '1', schema_version: '1' });
            }
            if (!saved.context || !['overview', 'live', 'bots'].every((name) => saved.sections?.[name])) return selection;
            return { ...selection, context: saved.context, sections: saved.sections };
        } catch { return selection; }
    } catch { return null; }
}

export function writeStatisticsView(viewer, controls, context, sections) {
    if (!viewer || !context) return;
    const names = ['overview', 'live', 'bots', ...(context.can_view_users ? ['users'] : [])];
    if (names.some((name) => !sections[name].data || sections[name].error)) return;
    try {
        const value = { controls, context, sections: Object.fromEntries(names.map((name) => [name, sections[name].data])), savedAt: Date.now() };
        let serialized = JSON.stringify(value);
        if (serialized.length * 2 > MAX_BYTES) serialized = JSON.stringify({ controls });
        storage()?.setItem(PREFIX + viewer, serialized);
    } catch { /* A full or blocked storage must not interrupt statistics. */ }
}
